/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Container, getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {
    $BetSelectPortrait,
    BetSelectProps,
} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/UIMainScreen/components/BetSelect';
import type {BetSelectOnChange} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/UIMainScreen/components/BetSelect';
import {Store} from '@gongxigames/framework/core';
import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {BuyFeatureStickTo} from '@gongxigames/framework/slot';

export type BuyFeatureControlsProps = BetSelectProps & {
    onBetChange: BetSelectOnChange;
    stickTo: BuyFeatureStickTo;
};

const BET_SELECT_PORTRAIT_POSITION: ResponsiveConf = {
    box: {x: '50%', y: '70%'},
};
const BET_SELECT_LANDSCAPE_POSITION: ResponsiveConf = {
    box: {x: '50%', y: '100%'},
    translate: {x: '0', y: '-108px'}
};
const BUTTON_LANDSCAPE_POSITION_LEFT: ResponsiveConf = {
    box: {x: '0%', y: '100%'},
    translate: {x: '207px', y: '-469px'}
};
const BUTTON_LANDSCAPE_POSITION_RIGHT: ResponsiveConf = {
    box: {x: '100%', y: '100%'},
    translate: {x: '-188px', y: '-900px'},
};
const BUTTON_PORTRAIT_POSITION: ResponsiveConf = {
    box: {x: '0%', y: '100%'},
    translate: {x: '189px', y: '-551px'}
};

export const $BuyFeatureControls: FC<BuyFeatureControlsProps> = (props) => {
    const stickTo: BuyFeatureStickTo = getProp(props.stickTo);
    const responsiveBetSelect = Store.computed(() => slotStore.stage_isPortrait.value ? BET_SELECT_PORTRAIT_POSITION : BET_SELECT_LANDSCAPE_POSITION);
    const responsiveBuyFeatureButton = Store.computed(() => {
        if (slotStore.stage_isPortrait.value) {
            return BUTTON_PORTRAIT_POSITION;
        }

        return stickTo === 'left' ? BUTTON_LANDSCAPE_POSITION_LEFT: BUTTON_LANDSCAPE_POSITION_RIGHT;
    });

    return <$Container>
        <$Container
            name={'ShowButtonContainer'}
            responsive={responsiveBuyFeatureButton}
        />
        <$BetSelectPortrait
            responsive={responsiveBetSelect}
            betList={props.betList}
            betCurrent={props.betCurrent}
            betFormatted={props.betFormatted}
            action={props.onBetChange}
            visible={props.visible}
            isBuyFeature={true}
        />
    </$Container>;
};